import { render, staticRenderFns } from "./CustomerCardApply.vue?vue&type=template&id=2c41138a&scoped=true"
import script from "./CustomerCardApply.vue?vue&type=script&lang=ts"
export * from "./CustomerCardApply.vue?vue&type=script&lang=ts"
import style0 from "./CustomerCardApply.vue?vue&type=style&index=0&id=2c41138a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c41138a",
  null
  
)

export default component.exports